import { queryClient } from "@/query-client";
import { queryOptions, useMutation } from "@tanstack/react-query";
import type { Project } from "../../types/project";
import projectService from "../services/project-service";

export const projectsQueryOptions = (params: Record<string, unknown> = {}) =>
	queryOptions({
		queryKey: ["projects", params],
		queryFn: () => projectService.list(params),
	});

export const projectQueryOptions = (id: string) =>
	queryOptions({
		queryKey: ["project", id],
		queryFn: () => projectService.findById(id),
	});

export const searchProjectsQueryOptions = (searchTerm: string) =>
	queryOptions({
		queryKey: ["projects", "search", searchTerm],
		queryFn: () => projectService.search(searchTerm),
	});

export const groupedProjectsQueryOptions = (params: Record<string, unknown> = {}) =>
	queryOptions({
		queryKey: ["projects", "grouped", params],
		queryFn: () => projectService.grouped(params),
	});

export const useProjectCreateMutation = () =>
	useMutation({
		mutationFn: (project: Omit<Project, "id" | "created_at" | "updated_at" | "deleted_at" | "sites_count">) => projectService.create(project),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ["projects"],
			});
		},
	});

export const useProjectUpdateMutation = (id: string) =>
	useMutation({
		mutationFn: (project: Partial<Project>) => projectService.updateById(id, project),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ["projects"],
			});
			queryClient.invalidateQueries({
				queryKey: ["project", id],
			});
		},
	});

export const useProjectDeleteMutation = () =>
	useMutation({
		mutationFn: (id: string) => projectService.deleteById(id),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ["projects"],
			});
		},
	});
